var VehicleHistory = (function () {

    function _init($parent, vehicleId, readonly) {

        var checkedRows = [];
        var historyTable = null;
        var $table = $parent.find('#VehicleTrackerHistoryListItemViewModelTable');
        if (historyTable == null) {
            var columnsDefs = $('#column-definition-second').text();
            if (columnsDefs != '') {
                var columns = JSON.parse(columnsDefs);
                var options = {
                    ajax: Url.action('TrackersHistoryTable/TableData/{0}'.format(vehicleId)),
                    rowId: 'Id',
                    language: {
                        url: Url.content("Content/Inspinia/plugins/dataTables/languages/Russian.json"),
                        select: {
                            rows: {
                                _: 'Выбрано %d строк',
                                1: 'Выбрана 1 строка',
                                2: 'Выбрано 2 строки',
                                3: 'Выбрано 3 строки',
                                4: 'Выбрано 4 строки'
                            }
                        }
                    },
                    processing: true,
                    pageLength: 100,
                    lengthMenu: [10, 25, 50, 100],
                    serverSide: true,
                    searching: true,
                    bFilter: false,
                    dom: "<'row'<'col-sm-6'l><'col-sm-6'p>>" +
                        "<'row'<'col-sm-12'tr>>" +
                        "<'row'<'col-sm-5'i><'col-sm-7'p>>",
                    columnDefs: [
                        {
                            orderable: false,
                            className: '',
                            targets: 0
                        }
                    ],
                    order: [[4, 'asc']]
                };
                if (!readonly) {
                    options.select = {
                        style: 'multi+shift',
                        selector: 'td:first-child'
                    };
                    options.columnDefs.push({
                        orderable: false,
                        className: 'select-checkbox',
                        targets: 0
                    });
                }

                for (var i = 0; i < columns.length; ++i) {
                    options.columnDefs.push({
                        name: columns[i].Name,
                        data: columns[i].Name,
                        orderable: columns[i].IsSortable,
                        visible: columns[i].IsVisible,
                        className: columns[i].CssClass,
                        targets: i + 1
                    });
                }

                historyTable = $table.DataTable(options)
                    .on('page', function(e, settings) {
                        checkAllItem();
                    })
                    .on('select', function(event, api, type, index) {
                        if (api && index) {
                            // в index возможен массив выбранных строк, поэтому запускаем цикл по всем элементам index
                            $.each(index, function(idx, number) {
                                var rowId = api.row(number).id(); // Получаем идентификатор по номеру строки

                                if (rowId && rowId != "undefined" && !checkedRows.contains(rowId)) {
                                    checkedRows.push(rowId);
                                }
                            });
                        }
                        checkAllItem();
                    })
                    .on('deselect', function(event, api, type, index) {
                        $.each(index, function(idx, number) {
                            var rowId = api.row(number).id();
                            if (rowId && rowId != "undefined") {
                                checkedRows.removeValue(rowId);
                            }
                        });

                        checkAllItem();
                    });

                columns
                    .filter(function(column) { return column.IsFilterable })
                    .forEach(function(column) {
                        ColumnsFilters[column.ColumnFilter.InitJsMethod](historyTable, $('#column_{Name}_filter'.format(column), $table), historyTable.column(column.Name + ':name'));
                    });
            }
        } else {
            refreshTable();
        }

        $parent
            .on('click', '[js=add-tracker-history]', function() {
                editHistory(null, vehicleId);
            })
            .on('click', '[js=delete-tracker-history]', function() {
                deleteHistory($.merge([], checkedRows));
            });
        $table
            .on('click', 'td:not(.select-checkbox)', function () {
                if (!readonly) {
                    var row = historyTable.row($(this).parent()).data();
                    editHistory(row.Id, vehicleId);
                }
            })
            .on('click', '[js=check-all]', function() {
                var checkVal = $(this).toggleClass('selected').hasClass('selected'); // Изменяем значение флага на противоположное, и записываем текущее значение
                var selectedRow = []; // массив id
                var info = historyTable.page.info(); // Получаем информацию о странице
                // Формируем массив id по всей странице
                for (var i = 0; i < info.length; i++) {
                    if (Number(historyTable.row(i).id())) {
                        selectedRow.push(i);
                    }
                }
                if (checkVal) {
                    historyTable.rows(selectedRow).select(); // Устанавливаем выделение для всех выбранных строк
                } else {
                    historyTable.rows(selectedRow).deselect(); // Снимаем выделение для всех выбранных строк
                }
            });

        // Функция изменения состояния мастер чекбокса
        function checkAllItem() {
            // Кол-во выбранных строк
            var rowsSelectedCount = 0;
            // Кол-во строк которые можно выбрать
            var rowsAllCount = 0;
            var info = historyTable.page.info(); // Получаем информацию о странице
            for (var i = 0; i < info.length; i++) {
                if (Number(historyTable.row(i).id())) {
                    rowsAllCount++;
                    if (checkedRows.contains(historyTable.row(i).id())) {
                        rowsSelectedCount++;
                    }
                }
            }
            // Если кол-во строк на странице равно кол-ву выбранных строк, то устанавливаем флаг в true
            $('[js=check-all]').toggleClass('selected', rowsSelectedCount > 0 && rowsSelectedCount === rowsAllCount);
        }

        function editHistory(historyId, vehicleId) {
            ModalConductor.activate(VehicleHistoryEditModal, historyId, vehicleId)
                .on('closed', (modalResult) => {
                    if (modalResult.ok) {
                        $('[js=tracker-id-info]').val(modalResult.trackerNumber);
                        $('[js=tracker-type-info]').val(modalResult.trackerType);
                        refreshTable();
                    }
                });
        }

        function refreshTable(resetChecked, idsForDeselect) {
            if (resetChecked) {
                resetCheckedRows(table, idsForDeselect);
            }
            historyTable.ajax.reload(null, false);
        }

        function resetCheckedRows(idsForDeselect) {
            if (idsForDeselect) {
                if (idsForDeselect.length) {
                    checkedRows = checkedRows.filter(function(rowId) {
                        return idsForDeselect.indexOf(rowId) !== -1 && idsForDeselect.indexOf(Number(rowId)) !== -1;;
                    });
                }
            } else {
                historyTable.rows().deselect();
                checkedRows.length = 0;
            }
            checkAllItem();
        }


        function deleteObject(ids) {
            $parent.busy();
            return $.ajax({
                    url: Url.action('api/vehicles/{0}/history'.format(vehicleId)),
                    type: 'DELETE',
                    dataType: 'json',
                    data: { ids: ids }
                })
                .done((data) => {
                    $('[js=tracker-id-info]').val(data.trackerNumber);
                    $('[js=tracker-type-info]').val(data.trackerType);
                    refreshTable(true, ids);
                    $parent.busy(false);
                })
                .fail(() => {
                    alert('Удаление данных записей невозможно');
                    $parent.busy(false);
                });
        };

        function deleteHistory(ids) {
            if (ids.length > 0 && confirm('Вы действительно хотите удалить {0} записей?'.format(ids.length))) {
                deleteObject(ids);
            }
        };
    }

    return {
        Init: _init
    };

}());
